export const alias_dropdown = {
        "alpha":[
                {label: "SEC", value: "22"},
                {label: "Audit Committee", value: "24"},
                {label: "Conference Call", value: "25"}
        ],
	"dev":[
		{label: "SEC", value: "22"},
		{label: "Audit Committee", value: "24"},
		{label: "Conference Call", value: "25"}
	],
	"beta":[
		{label: "SEC", value: "22"},
		{label: "Audit Committee", value: "24"},
		{label: "Conference Call", value: "25"}
	], 
	"prod":[
		{label: "SEC", value: "27"},
		{label: "Audit Committee", value: "29"},
		{label: "Conference Call", value: "28"}
	]
}

export const CRA_STATUS = {
	NO_PRE_WB: "No Pre - WB",
    NO_POST_WB: "No Post - WB",
    PENDING_UPLOAD: "Pending upload",
    READY_FOR_REVIEW: "Ready for Review",
    DATA_COPIED_TO_WORKIVA: "Data Copied to Workiva",
    DATA_SAVED_TO_WORKDOCS: "Data saved to Workdocs"
}

export const TEMPLATE_DOWNLOAD_URL = "https://amazonaccounting.awsapps.com/workdocs-amazon/index.html#/folder/9a5856280e54f8e7aab21e2fb04b882707797fc5d4f2decf746106ab233d4838"

export const BULK_UPLOAD_EXPECTED_HEADERS = [
    'Deliverable Reference', 'Title', 'Cadence', 'Disable This Deliverable',
    'Pre-WB Due Date and Time', 'Post-WB Due Date and Time', 'Pre-WB Post-Tax Due Date and Time (10-K only)',
    'Mandatory Documents', 'Uploaders Alias', 'Uploaders LDAP', 'Reviewers', 'Reviewers LDAP', 'Approvers', 'Approvers LDAP'
];